module.exports = (s) => {
  return [
    {
      name: 'ID',
      value: 'id',
    },
    {
      name: '素材规格名称',
      value: 'name',
      width: 290,
    },
    {
      name: '素材规格类型',
      value: 'type',
      format: (row, cell, cell_value) => {
        const type_obj = {
          '1': '图片',
          '2': '视频',
          '3': '落地页',
          '4': '组图',
        };
        return type_obj[cell_value];
      },
    },
    {
      name: '素材数量',
      value: 'num',
    },
    {
      name: '最小尺寸',
      value: 'min_size',
      format: (row, cell, cell_value) => {
        let size = 0;
        switch (cell_value) {
          case cell_value > 1024:
            size = cell_value / 1024 + 'M';
            break;
          default:
            size = cell_value + 'kb';
            break;
        }
        return size ? cell_value : '';
      },
    },
    {
      name: '最大尺寸',
      value: 'max_size',
      format: (row, cell, cell_value) => {
        return cell_value ? cell_value + 'kb' : '';
      },
    },
    {
      name: '素材宽度',
      value: 'width',
    },
    {
      name: '素材高度',
      value: 'height',
    },
    {
      name: 'MIME 类型',
      value: 'mime_type',
      format: (row, cell, cell_value) => {
        return cell_value.join(' | ');
      },
    },
    {
      name: '视频最短时长',
      value: 'min_millisecond',
      format: (row, cell, cell_value) => {
        return cell_value ? cell_value + 'ms' : '';
      },
    },
    {
      name: '视频最长时长',
      value: 'max_millisecond',
      format: (row, cell, cell_value) => {
        return cell_value ? cell_value + 'ms' : '';
      },
    },
    {
      name: '操作',
      value: 'id',
      fixed: 'right',
      align: 'center',
      width: 150,
      format: (row, cell, cell_value) => {
        const h = s.$createElement;
        const ele = h('div',
          null, [
            h('el-button',
              {
                props: {
                  'size': 'mini',
                },
                on: {
                  click: () => {
                    s.editFormat(row);
                  },
                },
              }, '编辑'),
            h('el-button',
              {
                props: {
                  'size': 'mini',
                  'type': 'danger',
                },
                on: {
                  click: () => {
                    s.removeMaterialFormat(cell_value).then((res) => {
                      s.getMaterialFormatList(s.material_format_list_params);
                    });
                  },
                },
              }, '删除'),
          ]);
        return ele;
      },
    },
  ];
};
